import PaymentType from './PaymentType'

export default function getPaymentBody ({
  method,
  paymentData,
  allowSplitPayment = false,
  splitPaymentData = null,
  useGiftCard = false,
  giftCardCoversOrder = false,
}) {
  // The CG gift-card balance is an extra payment leg, it never goes with a PO or `test`
  const payWithGiftCard = useGiftCard && ![PaymentType.PO, PaymentType.Test].includes(method)

  if (payWithGiftCard && giftCardCoversOrder) {
    return [{ method: PaymentType.GiftCard }]
  }

  if (payWithGiftCard) {
    // Only the method is named, the API prices each leg itself.
    // The gift-card leg goes last so the billing address is still read off leg one
    const paymentBody = getPaymentBody({ method, paymentData, allowSplitPayment, splitPaymentData })
    return [...(Array.isArray(paymentBody) ? paymentBody : [paymentBody]), { method: PaymentType.GiftCard }]
  }

  const paymentBody = {}
  paymentBody.method = method

  const braintreeDeviceData = JSON.parse(sessionStorage.getItem('braintreeDeviceData'))
  const deviceSessionId = braintreeDeviceData?.device_session_id

  if (method === PaymentType.BE) {
    paymentBody.budget_id = paymentData?.id;
  } else if (method === PaymentType.PO) {
    paymentBody.poNumber = paymentData?.poNumber;
    if (paymentData?.fileLink) {
      paymentBody.poFile = paymentData.fileLink
      paymentBody.poFileName = paymentData?.poFileName ?? 'po-file'
    }
  } else if (method === PaymentType.ACH) {
    paymentBody.token = paymentData?.token
    paymentBody.deviceData = deviceSessionId ?? null
  } else if (method === PaymentType.CC) {
    paymentBody.deviceData = deviceSessionId ?? null

    if (Object.hasOwn(paymentData, 'token')) {
      paymentBody.token = paymentData?.token
    } else {
      paymentBody.paymentMethodNonce = paymentData?.payment?.paymentMethodNonce
      paymentBody.billingAddress = paymentData?.billingAddress
      paymentBody.bin = paymentData?.binNumber
    }
  } else if (method === PaymentType.CC_Bluesnap) {
    paymentBody.card_last_four_digits = paymentData?.cardLastFourDigits
    paymentBody.card_type = paymentData?.cardType
    paymentBody.bin = paymentData?.binNumber
  } else if (method === PaymentType.ACH_Bluesnap) {
    paymentBody.public_routing_number = paymentData?.publicRoutingNumber
    paymentBody.public_account_number = paymentData?.publicAccountNumber
  }

  if (allowSplitPayment && method === PaymentType.BE && splitPaymentData) {
    const addSplitPaymentData = paymentData.split_payment_allowed

    if (addSplitPaymentData) {
      return [
        paymentBody,
        getPaymentBody({ method: PaymentType.CC, paymentData: splitPaymentData })
      ]
    }
  }

  return paymentBody
}
